export default {
  // url: 'http://172.31.6.47:8099/portal-web'
  url: `${sessionStorage.getItem('serviceUrl')}portal-web`,
  imgUrl: `${sessionStorage.getItem('serviceUrl')}`
}